<template>
	<div class="site-backups-list-wrapper">
		<div>
			<div class="row mb-5">
				<div class="col-md-4 offset-md-4 pull-right">
					<select class="form-control" v-model="selectedAction" v-on:change="actionChanged()">
						<option disabled value="">Select DNS Templates</option>
						<option v-for="(action, index) in actions" :value="action.action" :key="index + '_' + action.name">
							{{action.name}}
						</option>
					</select>
				</div>
				<div class="col-md-4 pull-right">
					<div class="custom-file">
						<input type="file" class="custom-file-input" id="customFile" ref="file" @change="importRecords($event)" :disabled="loading">
						<label v-if="this.file" class="custom-file-label" for="customFile">{{this.file.name}}</label>
						<label v-else class="custom-file-label" for="customFile">Choose file for import (.txt)</label>
					</div>
				</div>
			</div>
			<dns-create :account="account" :loading="loading" v-on:update-list="list" v-on:update-loading="updateLoading"></dns-create>
			<div v-if="!loadingData" class="loader"></div>
			<dns-items v-else :records="records" :account="account" :loading="loading" v-on:update-list="list" v-on:update-loading="updateLoading"></dns-items>
		</div>
	</div>
</template>

<script>
	import swal from "sweetalert2";
	import _ from "lodash";
	import refreshToken from "../../../mixins/refreshTokenMixin";
	import DnsCreate from "./DnsCreate";
	import DnsItems from "./DnsItems";

	export default {
		name: "DnsList",
		mixins: [refreshToken],
		props: {
			account: {
				type: Object,
				required: true
			}
		},
		components: {
			DnsCreate,
			DnsItems
		},
		data: function () {
			return {
				domain: '',
				file: '',
				records: [],
				loading: false,
				loadingData: false,
				actions:[
					{
						name: 'BigScoots Default',
						action: '0'
					},
					{
						name: 'GSuite',
						action: '1'
					}
				],
				selectedAction:'',
			}
		},
		computed: {
			accounts() {
				return this.$store.getters["hosting/accounts"];
			},
			clientID() {
				return this.$store.getters.getCustomerID;
			},
			userToken() {
				return this.$store.getters.getUserToken;
			},
			user() {
				return this.$store.getters.user;
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			}
		},
		watch: {
			account: function (value) {
				this.domain = value.domain;
				this.list();
			}
		},
		beforeMount() {
			this.domain = this.account.domain;
		},
		mounted() {
			this.list();
		},
		methods: {
			actionChanged(){
				// let defaultMessage = 'This will completely remove all current DNS records and replace them with the BigScoots default records to point your site AND email to our hosting service';
				let defaultMessage = 'Are you sure to add the BigScoots default DNS records in your DNS list';
				if(this.selectedAction === '1') {
					defaultMessage = 'This will remove all current MX records and replace them with the GSuite MX records to point your email to Google\'s GSuite'
				}
				swal({
					title: "Are you sure?",
					text: defaultMessage,
					type: "question",
					confirmButtonText: "Yes Proceed",
					confirmButtonColor: "#6ACF98",
					showCancelButton: true,
					cancelButtonText: "No Thanks",
					cancelButtonColor: "#EE8057"
				})
					.then(async result => {
						// Check if the user has clicked YES
						if(result.value) {
							this.$store.dispatch("async/stateUpdate", { state: false});
							await this.$store.dispatch('dns/setTemplates', { ip:this.account.serverIP,domain:this.account.domain,action: this.selectedAction });
							let ids = [];
							switch (this.selectedAction) {
								case '0':
									for(let record of this.records){
										ids.push(record.id);
									}
									break;
								case '1':
									ids = _.map(this.records.filter(item => item.type === 'MX'), 'id');
									break;
							}
							let templates = this.$store.getters["dns/getTemplates"](this.selectedAction);
							if(this.selectedAction === '1' && ids.length > 0){
								console.log('Deleting MX Records...');
								this.$http.post('dns/bulk-delete', {
									grant_type: "token",
									token: this.userToken,
									domain: this.account.domain,
									cloudflare_email: this.account.cloudflare.username,
									cloudflare_api_key: this.account.cloudflare.apiKey,
									cloudflare_zone: this.account.cloudflare.zone_id,
									identifiers: ids
								})
										.then(() => {
											this.addDefualtRecords(templates);
										})
										.catch((err) => {
											const {response} = err;
											let responseMessage = response.data.message;
											if (response.status === 422) {
												responseMessage = _.map(response.data.errors, 'msg').join('. ')
											} else if (response.status === 401) {
												responseMessage = "You need update token. Please Try Again!";
												this.refreshToken();
											}
											this.action = null;
											swal({
												title: "Something went wrong!",
												html: responseMessage,
												type: "error",
												confirmButtonText: "Try Again!",
												confirmButtonColor: "#EE8057"
											});
											if (response.status !== 401) {
												this.addLog({
													name: this.user.firstName + " " + this.user.lastName,
													message: "Error delete dns. Message: " + responseMessage,
													level: "danger"
												});
											}
										});
							}else{
								this.addDefualtRecords(templates);
							}
						}else{
							this.selectedAction = '';
						}
					});

			},
			addDefualtRecords(templates){
				this.$http.post("dns/bulk-create", {
					grant_type: "token",
					token: this.userToken,
					cloudflare_email: this.account.cloudflare.username,
					cloudflare_api_key: this.account.cloudflare.apiKey,
					cloudflare_zone: this.account.cloudflare.zone_id,
					templates: templates
				})
						.then(() => {
							this.$store.dispatch("async/stateUpdate", { state: true});
							this.list();
							swal({
								title: "Message!",
								html: "Your selected DNS template has been loaded successfully!",
								type: "success",
								confirmButtonText: "OK!",
								confirmButtonColor: "#EE8057"
							});

						})
						.catch((err) => {
							const {response} = err;
							let responseMessage = response.data.message;
							if (response.status === 422) {
								responseMessage = _.map(response.data.errors, 'msg').join('. ')
							}else if(response.status === 401){
								responseMessage = "You need update token. Please Try Again!";
								this.refreshToken();
							}

							swal({
								title: "Something went wrong!",
								html: responseMessage,
								type: "error",
								confirmButtonText: "Try Again!",
								confirmButtonColor: "#EE8057"
							});
							if(response.status !== 401) {
								this.addLog({
									name: this.user.firstName + " " + this.user.lastName,
									message: "Error create DNS record. Message: " + responseMessage,
									level: "danger"
								});
							}
						});
			},
			list() {
				this.loadingData = false;
				this.$http.post("dns", {
					domain: this.domain,
					grant_type: "token",
					token: this.userToken,
					cloudflare_email: this.account.cloudflare.username,
					cloudflare_api_key: this.account.cloudflare.apiKey,
					cloudflare_zone: this.account.cloudflare.zone_id,
				})
					.then((response) => {
						this.loadingData = true;
						this.records = response.data.data;
					})
					.catch((err) => {
						if (err.response.status == 401) {
							this.refreshToken(() => {
								this.list()
							})
						} else {
							this.addLog({
								name: this.user.firstName + " " + this.user.lastName,
								message: `Error show DNS list. Message: ${err.message} Code: ${err.code}`,
								level: "danger"
							});
						}
					})
					.finally(()=>{
						this.loadingData = true;
					});
			},
			importRecords(event) {
				this.file = this.$refs.file.files[0];
				let formData = new FormData();
				formData.append('importFile', this.file);
				formData.append('grant_type', "token");
				formData.append('token', this.userToken);
				formData.append('cloudflare_email', this.account.cloudflare.username);
				formData.append('cloudflare_api_key', this.account.cloudflare.apiKey);
				formData.append('cloudflare_zone', this.account.cloudflare.zone_id);
				formData.append('domain', this.account.domain);

				this.$http(
					{
						method: 'post',
						url: '/dns/import',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						data: formData
					}
				).then((response) => {
					this.list();
					const { result, messages } = response.data.data;
					let message = '';
					if(messages){
						messages.map(item=>message += `<p>${item.message}</p>`);
					}
					swal({
						title: "Message!",
						html: `<p>You successfully imported DNS records.</p> <p>Records added: ${result.recs_added}.</p><p>Total records parsed: ${result.total_records_parsed}</p> ${message}`,
						type: "success",
						confirmButtonText: "OK!",
						confirmButtonColor: "#EE8057"
					});
				})
					.catch((err) => {
						let responseMessage = err.response.data.message;
						if (err.response.status === 422) {
							responseMessage = _.map(err.response.data.errors, 'msg').join('. ')
						}else if(err.response.status === 401){
							responseMessage = "You need update token. Please Try Again!";
							this.refreshToken();
						}

						swal({
							title: "Something went wrong!",
							html: responseMessage,
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.addLog({
							name: this.user.firstName + " " + this.user.lastName,
							message: "Error import DNS records. Message: " + responseMessage,
							level: "danger"
						});
					})
					.finally(() => {
						this.file = null;
						event.target.value = '';
					});
			},
			updateLoading(value){
				this.loading = value;
			}
		}
	};
</script>

<style>
	.custom-file-label::after {
		line-height: 25px;
	}

	.custom-file-label {
		line-height: 25px;
	}
</style>
